/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type GdprExportStatus =
  (typeof GdprExportStatus)[keyof typeof GdprExportStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GdprExportStatus = {
  Pending: 0,
  Processing: 1,
  Completed: 2,
  Failed: 3,
  Expired: 4,
} as const;
